/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { deepCopy } from 'ionic-angular/util/util';
import 'rxjs/add/operator/map';
import * as CryptoJS from 'crypto-js';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
import { NG_ASYNC_VALIDATORS } from '@angular/forms';
import { HttpResponse } from '@angular/common/http';
/// *** Custom import ***///
import { Globals } from '../app/globals';
import { EnvVariables } from '../app/environment-variables/environment-variables.token';
import { MainHubProvider } from './serverHubs/main';

@Injectable()
export class SessionProvider {
  /// *** Local data ***///
  public data: {
    userID: string,
    contactID: string,
    userName: string,
    token: string,
    activeAccount: any
  };
  public accounts: any;
  public notificationCount: number = 0;
  constructor(
    // *** System
    private events: Events,
    private http: Http,
    private storage: Storage,
    private toastCtrl: ToastController,
    // *** Custom 
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private mainHubProvider: MainHubProvider) {
  }

  /// *** Charger la session à partir du store local
  public load() {
    return new Promise((resolve, reject) => {
      let sessionStore = this.storage.get(this.globals.USER_SESSION_KEY).then(
        (data) => {
          if (data) {
            let dataStr = CryptoJS.AES.decrypt(data.toString(), this.globals.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
            this.data = JSON.parse(dataStr);
            console.log(this.data);
            resolve();
           
          }
          else {
            this._reset().then(
              (succeed) => { resolve(); },
              (error) => { reject(); });
          }
        },
        (error) => {
          this.globals.showStorageError(this.toastCtrl, error);
          this._reset().then(
            (succeed) => { reject(); },
            (error) => { reject(); });
        });
    });
  }

  /// *** Enregistrer la session dans le store local
  public persist() {
    return new Promise((resolve, reject) => {
      let dataCrypt: string = CryptoJS.AES.encrypt(JSON.stringify(this.data), this.globals.CRYPTO_KEY).toString();
      this.storage.set(this.globals.USER_SESSION_KEY, dataCrypt).then(
        (succeed) => { resolve(); },
        (error) => {
           this.globals.showStorageError(this.toastCtrl, error);
          reject();
        });
    });
  }

  /// *** Vérifier si la session est valide
  public validate() {
    return new Promise((resolve, reject) => {
      if ((this.data == null) || (this.data.userID == null)) {
        reject();
      }
      else {
        this._loadAccounts().then(
          (succeed) => {
            this._setNotificationsCount();
            this.mainHubProvider.subscribe(this.data.userID);
            this._eventsSub();
            resolve();
          },
          (error) => { reject(); }
        );
      }
    });
  }

  /// *** Valider les informations de connection et initialiser la session
  public login(credentials: any) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = new URLSearchParams();
      requestBody.append('client_id', 'MicroBroker');
      requestBody.append('grant_type', 'password');
      requestBody.append('username', credentials.login);
      requestBody.append('password', credentials.password);
      this.http.post(this.envVariables.securityTokenEndpoint, requestBody.toString(), options).map(res => res.json()).subscribe(
        (data) => {
          let session = JSON.parse(atob(data.access_token.split('.')[1]));
          this.data.userID = session.UserID;
          this.data.contactID = session.ContactID;
          this.data.userName = session.UserName;
          this.data.activeAccount = {
            CustomerID: session.DefaultCustomerID,
            AccountID: session.DefaultAccountID,
          };
          this.data.token = data.access_token;
          this.persist().then(
            (succeed) => {
              this.validate().then(
                (succeed) => { resolve(); },
                (error) => {
                  this._reset().then(
                    (succeed) => { reject(); },
                    (error) => { reject(); }
                  );
                }
              );
            },
            (error) => {
              this._reset().then(
                (succeed) => { reject(); },
                (error) => { reject(); }
              );
            });
        },
        (error) => {
          let msg = JSON.parse(error._body).error_description;
          this._reset().then(
            (succeed) => { reject(msg); },
            (error) => { reject(msg); }
          );
        });
    });
  }

  /// *** Déconnecter l'utilisateur et reset de la session
  public logout() {
    return new Promise((resolve, reject) => {
      this._reset().then(
        (succeed) => {
          this.events.publish('SessionProvider.logout');
          this._eventsUnsub();
          resolve();
        },
        (error) => { reject(); });
    });
  }

  //#region Helpers
  private _defaultData() {
    return {
      userID: null,
      contactID: null,
      userName: null,
      token: null,
      activeAccount: null,
    };
  }

  /// *** Reset de la session
  private _reset() {
    return new Promise((resolve, reject) => {
      this.data = this._defaultData();
      this.accounts = [];
      this.persist().then(
        (succeed) => { resolve() },
        (error) => { reject(); }
      );
    });
  }

  /// *** Charger la liste des comptes
  private _loadAccounts() {
    return new Promise((resolve, reject) => {
      try {
        let requestHeaders = new Headers();
        requestHeaders.append('Content-Type', 'application/json');
        let requestParams = new URLSearchParams();
        requestParams.append('UserID', this.data.userID);
        let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
        this.http.get(this.envVariables.account_userAccounts_url, options).map(res => res.json()).subscribe(
          (data) => {
            this.accounts = deepCopy(data);
            // Default
            let activeAccount = this.data.activeAccount ?
              this.accounts.find(item => item.AccountID == this.data.activeAccount.AccountID) :
              null;
            if (!activeAccount)
              activeAccount = this.accounts.find(item => item.IsDefault == true);
            this.data.activeAccount = activeAccount;
            this.persist().then(
              (succeed) => { resolve(); },
              (error) => { reject(); });
          },
          (error) => {
            this.globals.showCommunicationError(this.toastCtrl, error);
            reject();
            /*this.logout().then(
              (succeed) => { resolve(); },
              (error) => { reject(); });*/
          });
      }
      catch (error) {
        this.globals.showCommunicationError(this.toastCtrl, error);
        reject();
      }
    });
  }

  /// *** Charger la liste des comptes
  private _setNotificationsCount() {
    return new Promise((resolve, reject) => {
      try {
        let requestHeaders = new Headers();
        requestHeaders.append('Content-Type', 'application/json');
        let requestParams = new URLSearchParams();
        requestParams.append('UserID', this.data.userID);
        let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
        this.http.get(this.envVariables.account_pendingNotificationsCount_url, options).map(res => res.json()).subscribe(
          (data) => {
            this.notificationCount = data;
            resolve();
          },
          (error) => {
            this.globals.showCommunicationError(this.toastCtrl, error);
            reject();
          });
      }
      catch (error) {
        this.globals.showCommunicationError(this.toastCtrl, error);
        reject();
      }
    });
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsSub() {
    this.events.subscribe('MainHubProvider.notify',
      (notificationID: number, count: number, approvalCount: number) => {
        try {
          this.notificationCount = count;
          let requestHeaders = new Headers();
          requestHeaders.append('Content-Type', 'application/json');
          let requestParams = new URLSearchParams();
          requestParams.append('NotificationID', notificationID.toString());
          let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
          this.http.get(this.envVariables.account_notification_url, options).map(res => res.json()).subscribe(
            (data) => {
              if ((data['Nature'] == 1) || (data['Nature'] == 2))
                this.globals.showInfo(this.toastCtrl, data['Message']);
              if (data['Nature'] == 3)
                this.globals.showError(this.toastCtrl, data['Message']);
              if ((data['Nature'] == 4) || (data['Nature'] == 5))
                this.globals.showConfirm(this.toastCtrl, data['Message']);
            },
            (error) => { });
        }
        catch (error) { }
      });
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsUnsub() {
    try {
      this.events.unsubscribe('MainHubProvider.notify');
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
  //#endregion
}


// WEBPACK FOOTER //
// ./src/providers/session.ts